module.exports = __webpack_public_path__ + "static/media/gsuite-recent-alerts.56d1d34b.png";